import { formatDistanceToNow } from 'date-fns';
import { ja } from 'date-fns/locale';

export const formatLastLoginTime = (lastLoginAt) => {
    if (!lastLoginAt) return null;

    const date = new Date(lastLoginAt);
    return formatDistanceToNow(date, { addSuffix: true, locale: ja });
};
